import React from 'react';
import SEO from '../components/SEO';
import ContactMap from '../components/ContactMap';
import ContactSection from '../components/ContactSection';


const ContactPage = ({ language }) => {
  return (
    <>
      <SEO
        title="Contact Us"
        description="Get in touch with Blue Nest Hotel. Find our location, contact details, and send us a message."
        url="/contact"
      />
      <ContactMap />
      <ContactSection language={language} />
    </>
  );
};

export default ContactPage;
